export default {
    // shared
    bs_save: "Save",
    bs_cancel: "Cancel",
    bs_error: "Error",
    bs_failed: "Failed",
    bs_on: "On",
    bs_off: "Off",
    bs_total: "Total",
    bs_tax: "Tax",
    bs_name: "Name",
    bs_status: "Status",
    bs_edit: "Edit",
    bs_delete: "Delete",
    bs_phone: "Phone",
    bs_email: "Email",
    bs_title_label: "Title",
    bs_description: "Description",
    bs_price: "Price",
    bs_active: "Active",
    bs_inactive: "Inactive",
    bs_products: "Products",
    bs_subtotal: "Subtotal",
    bs_discount: "Discount",
    bs_delivery_fee: "Delivery Fee",
    bs_notes: "Notes",
    bs_could_not_save: "Could not be saved!",
    bs_swal_delete_title: "Delete Item?",
    bs_swal_text: "Are you sure?",
    bs_swal_confirm: "Yes, Delete it!",
    bs_success: "Success",

    // productCategory
    bscat_category_name_ph: "Category Name",

    // productEditDescription
    bsed_add_description_ph: "Add description",

    // productEditName
    bsen_add_name_ph: "Add product name",

    // OrderForm
    bsof_edit_order: "Edit Order",
    bsof_create_order: "Create Order",
    bsof_first_name: "First name",
    bsof_first_name_ph: "John",
    bsof_last_name: "Last name",
    bsof_last_name_ph: "Doe",
    bsof_phone_ph: "+123456789",
    bsof_email_ph: "john@example.com",
    bsof_order_source: "Order source",
    bsof_source_cart: "Cart",
    bsof_source_manual: "Manual",
    bsof_source_whatsapp: "whatsapp",
    bsof_notes_ph: "Add notes...",
    bsof_discount_label: "Discount %",

    // OrderItemsTable
    bsoit_product_service: "Product / Service",
    bsoit_qty: "Qty",
    bsoit_choose_product_ph: "Choose a Product",
    bsoit_product_note_ph: "Product note:",
    bsoit_add_product: "+ Product",
    bsoit_none: "None",

    // tableOrders
    bsto_order: "Order",
    bsto_customer_name: "Customer Name",
    bsto_source: "Source",
    bsto_items: "Items",
    bsto_payment: "Payment",
    bsto_in_progress: "In Progress",
    bsto_pending: "Pending",
    bsto_paid: "paid",
    bsto_unpaid: "UnPaid",
    bsto_declined: "Declined",
    bsto_in_transit: "In Transit",
    bsto_out_for_delivery: "Out for Delivery",
    bsto_ready_for_pickup: "Ready for Pickup",
    bsto_picked_up: "Picked Up",
    bsto_processing: "Processing",
    bsto_shipped: "Shipped",
    bsto_delivered: "Delivered",
    bsto_cancelled: "Cancelled",
    bsto_order_details: "Order Details",

    // bStore_orders
    bsord_add_order: "Add Order",
    bsord_search_ph: "Search orders...",
    bsord_item_required: "Order must have at least one item.",

    // bStore_products
    bsprod_remove_category_error: "To remove it must be without products",
    bsprod_swal_delete_prefix: "Delete",

    // btns_cart
    bsbtn_add_to_cart: "Add to cart",
    bsbtn_contact: "Contact",

    // optsPrice / productEditPrice
    bsop_qty_selector: "Quantity Selector:",
    bsop_price_type: "Price type",
    bsop_fixed: "fixed",
    bsop_variable: "variable",
    bsop_contact: "contact",
    bsop_sell_status: "Sell Status",
    bsop_available: "available",
    bsop_showcase: "showcase",
    bsop_sold_out: "sold out",
    bsop_visibility: "Visibility",
    bsop_amount: "Amount",
    bsop_amount_ph: "E.g. 1.00",
    bsop_discount_ph: "E.g. 10%",
    bsop_final_price: "Final Price",
    bsop_hidden_product: "Hidden Product",
    bsop_hidden_price: "Hidden Price",
    bsop_from: "From",
    bsop_wrong_format: "Error, wrong format, maximum 2 decimals.",
    bsop_incorrect_amount: "Incorrect amount.",

    // productList
    bspl_new_item: "+ New Item",
    bspl_product_name_ph: "product name",

    // productSlider
    bssl_delete_product: "Delete product",

    // bStore_setup_booking
    bssb_booking_calendar: "Booking calendar:",
    bssb_show_dates: "Show available dates",
    bssb_schedule: "Schedule:",
    bssb_show_times: "Show available times",
    bssb_instructions: "Instructions:",
    bssb_instructions_ph: "Enter special instructions for customers...",

    // bStore_setup_categories
    bssc_edit_currency: "Edit Currency:",
    bssc_usd: "$ USD",
    bssc_pen: "S./ Sol PEN",
    bssc_add_new: "Add new:",
    bssc_category_name_ph: "Category name",
    bssc_no_record: "No record",
    bssc_delete_title: "Delete Item?",

    // bStore_setup_order
    bsso_tax_label: "Tax:",
    bsso_delivery_fee_label: "Delivery Fee:",
    bsso_privacy_link: "Link Privacy & Policy:",
    bsso_terms_link: "Link Terms & Conditions:",
    bsso_return_link: "Link Return Policy:",

    // bsite_bStore_deals
    bsdl_title_ph: "Title deals",
    bsdl_exclusive_offers: "Exclusive offers and discounts available today. Limited-time promotions.",
    bsdl_title_section: "Title",
    bsdl_desc_optional: "Description: (Optional)",
    bsdl_add_deal: "Add Deal",
    bsdl_new_deal: "New Deal",
    bsdl_edit_deal: "Edit Deal",
    bsdl_deal_title_ph: "Deal title",
    bsdl_optional_label: "(Optional)",
    bsdl_upload_image: "Upload image",
    bsdl_enable_message: "Enable Today's Deals to manage daily promotions.",
    bsdl_title_required: "Title must be at least 3 characters.",
    bsdl_today_deals: "Today's Deals",
    bsdl_failed_save_title: "Failed to save title.",
    bsdl_failed_save_content: "Failed to save content.",
    bsdl_failed_save_deal: "Failed to save deal.",
    bsdl_failed_delete_deal: "Failed to delete deal.",
    bsdl_failed_save_deals: "Failed to save deals.",
    bsdl_delete_deal: "Delete Deal?",

    // bStore_setup (tab menu)
    bssu_setup_title: "Setup bStore",
    bssu_categories: "Categories",
    bssu_orders: "Orders",
    bssu_booking: "Booking",
    bssu_notifications: "Notifications",

    // bStore_setup_noti
    bssn_whatsapp: "WhatsApp",
    bssn_contact_btn_text: "Contact button text",
    bssn_auto_response: "Auto Response",
    bssn_sms: "SMS",
    bssn_send_response: "Send response to customer",
    bssn_default_contact: "Contact",
    bssn_default_ws_msg: "I'm interested in the product: *{{product_name}}* from your store.",

    // productUpload
    bspu_gallery: "Product Gallery:",
    bspu_cover_image: "Cover Image: (required)",
    bspu_add_image: "add image",
    bspu_upload_error: "File could not be uploaded!",
    bspu_to_remove_items: "To remove it must be without item",
    bspu_could_not_delete: "Could not be delete!",
}
